import { ESupportMessageSubject } from 'shared/api';

export const SUPPORT_SUBJECT_LABELS: Record<ESupportMessageSubject, string> = {
  [ESupportMessageSubject.AccountIssue]: 'Проблема с аккаунтом',
  [ESupportMessageSubject.TechnicalIssue]: 'Техническая проблема',
  [ESupportMessageSubject.VaccinationScheduleIssue]: 'Вопрос по вакцинам и графику',
  [ESupportMessageSubject.Suggestions]: 'Предложения',
  [ESupportMessageSubject.DataConsent]: 'Отзыв согласия на обработку данных',
  [ESupportMessageSubject.Other]: 'Другое',
};

// Порядок опций в дропдауне фильтра
export const SUPPORT_SUBJECT_OPTIONS: ESupportMessageSubject[] = [
  ESupportMessageSubject.AccountIssue,
  ESupportMessageSubject.TechnicalIssue,
  ESupportMessageSubject.VaccinationScheduleIssue,
  ESupportMessageSubject.Suggestions,
  ESupportMessageSubject.DataConsent,
  ESupportMessageSubject.Other,
];

// Fallback на сырой ключ, если бэк добавит новую категорию раньше фронта
export const getSupportSubjectText = (s: ESupportMessageSubject): string => SUPPORT_SUBJECT_LABELS[s] ?? s;
